// Import Sentry FIRST
import "./sentry.js";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  // Temporarily disable StrictMode in development to avoid findDOMNode warnings from Ant Design
  // StrictMode will be re-enabled in production
  import.meta.env.DEV ? (
    <App />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
);
